import React from "react";
import { Auth } from "aws-amplify";
import {
  Stack,
  Link,
  FormControl,
  InputLabel,
  FilledInput,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { SignUpFormChanged } from "contexts/Auth/SignUpFormChanged";
import { NotificationChanged } from "contexts/Notifications/NotificationChanged";
import { AuthFlowChanged } from "contexts/Auth/AuthFlowChanged";
import { UserSignedUp } from "contexts/Auth/UserSignedUp";

const initialForm = {
  username: "",
  password: "",
  email: "",
};

const SignUp = () => {
  const [signUpForm, setSignUpForm] = React.useState(initialForm);

  return (
    <Stack direction="column" spacing={2} sx={{ width: "300px" }}>
      <SignUpFormChanged.Provider value={{ signUpForm, setSignUpForm }}>
        <SignUpForm />
        <SignUpButton />
      </SignUpFormChanged.Provider>
      <LinkToSignIn />
    </Stack>
  );
};

const SignUpForm = () => {
  const { signUpForm, setSignUpForm } = React.useContext(SignUpFormChanged);

  const onChange = (event) => {
    setSignUpForm(() => ({
      ...signUpForm,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <React.Fragment>
      <FormControl focused size="small" sx={{ width: "100%" }} variant="filled">
        <InputLabel>Username</InputLabel>
        <FilledInput name="username" disableUnderline onChange={onChange} />
      </FormControl>
      <FormControl focused size="small" sx={{ width: "100%" }} variant="filled">
        <InputLabel>Password</InputLabel>
        <FilledInput
          name="password"
          type="password"
          disableUnderline
          onChange={onChange}
        />
      </FormControl>
      <FormControl focused size="small" sx={{ width: "100%" }} variant="filled">
        <InputLabel>Email</InputLabel>
        <FilledInput name="email" disableUnderline onChange={onChange} />
      </FormControl>
    </React.Fragment>
  );
};

const SignUpButton = () => {
  const { signUpForm } = React.useContext(SignUpFormChanged);
  const { setNotification } = React.useContext(NotificationChanged);
  const { setAuthFlow } = React.useContext(AuthFlowChanged);
  const { setSignedUpUser } = React.useContext(UserSignedUp);

  const [loading, setLoading] = React.useState(false);
  const handleClick = async () => {
    try {
      setLoading(true);
      const { username, password, email } = signUpForm;

      await Auth.signUp({ username, password, attributes: { email } });

      setLoading(false);
      setSignedUpUser(username);
      setAuthFlow("confirmSignUp");
    } catch (error) {
      const notification = {
        opened: true,
        message: error.message,
        severity: "error",
      };

      setNotification(notification);
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      loading={loading}
      disabled={loading ? true : false}
      variant="contained"
      size="small"
      onClick={handleClick}
    >
      Sign up
    </LoadingButton>
  );
};

const LinkToSignIn = () => {
  const { setAuthFlow } = React.useContext(AuthFlowChanged);

  const handleClick = (event) => {
    setAuthFlow("signIn");
  };

  return (
    <Link component="button" variant="body2" onClick={handleClick}>
      I have an account
    </Link>
  );
};

export default SignUp;
